import { useStore } from '../../app/StoreContext';

export function About() {
  const { store } = useStore();
  if (!store) return null;
  return (
    <div className="page-narrow about">
      {store.branding.logoUrl && <img className="about-logo" src={store.branding.logoUrl} alt="" />}
      <h1>{store.displayName}</h1>
      {store.about
        ? store.about.split(/\n{2,}/).map((p, i) => <p key={i}>{p}</p>)
        : <p className="muted">No description yet.</p>}
    </div>
  );
}
